import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ag-checkbox-header" },
    [
      _c(VCheckbox, {
        attrs: {
          "aria-label": "Select all",
          "hide-details": "",
          dense: "",
          indeterminate: _vm.isIndeterminate,
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.isChecked,
          callback: function ($$v) {
            _vm.isChecked = $$v
          },
          expression: "isChecked",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }